import { posthog } from "posthog-js"
import { PostHogProvider as PostHogProviderBase } from "posthog-js/react"
import { useEffect } from "react"

import { useAuthStateChanges } from "@repo/supabase/hooks/use-auth-state-changes"
import { logger } from "@repo/utils/logger"
import { sharedConfig } from "~/lib/config/shared"

const log = logger.child({
  module: "web-app/PostHogProvider",
})

export function PostHogProvider({ children }: React.PropsWithChildren) {
  useEffect(() => {
    if (!sharedConfig.posthog.apiKey) {
      log.warn("No PostHog API key found")
      return
    }

    posthog.init(sharedConfig.posthog.apiKey, {
      defaults: "2025-05-24",
      person_profiles: "identified_only",
      api_host: sharedConfig.posthog.apiHost,
      ui_host: sharedConfig.posthog.uiHost,
      bootstrap: {
        featureFlags: {
          release: sharedConfig.appVersion,
        },
      },
    })

    log.info("PostHog initialized", {
      apiHost: sharedConfig.posthog.apiHost,
      version: sharedConfig.appVersion,
    })
  }, [])

  useAuthStateChanges({
    async onEvent(event, session) {
      switch (event) {
        case "INITIAL_SESSION":
        case "USER_UPDATED":
        case "SIGNED_IN": {
          if (!session?.user) {
            return
          }

          posthog.identify(session?.user.id, {
            email: session?.user.email,
            name: session?.user.user_metadata.name,
          })
          break
        }

        case "SIGNED_OUT": {
          posthog.reset()
          break
        }
      }
    },
  })

  return <PostHogProviderBase client={posthog}>{children}</PostHogProviderBase>
}
